module.exports = __webpack_public_path__ + "media/images/allianz-banner-ad-4f4abf95.jpg";